import axios, { AxiosResponse } from 'axios'
import { env } from '@js/utils/env'
import getStoreName from '@js/api/utils/getStoreName'
import getBearerToken from '@js/api/utils/getBearerToken'
import gql from '@js/api/utils/gql'

export interface CustomerOrder {
  order_id: number
  registration_number: string
  created_at: string
  course_type: string
  primary_category: string
  payment_method: string
  first_name: string
  last_name: string
  last4cc: string
  email: string
  street: string
  city: string
  state: string
  country: string
  grand_total: number
}

interface GetCustomerOrderResponse {
  data: {
    getWceiOrder: CustomerOrder | null
  }
  errors?: [{ message: string }]
}

const getOrderQuery = gql`
  query getWceiOrder($order_id: Int!) {
    getWceiOrder(order_id: $order_id) {
      order_id
      registration_number
      created_at
      course_type
      primary_category
      payment_method
      first_name
      last_name
      last4cc
      email
      street
      city
      state
      country
      grand_total
    }
  }
`

export const getCustomerOrder = async (orderId: number): Promise<CustomerOrder | null> => {
  const bearerToken = getBearerToken()

  const { data }: AxiosResponse<GetCustomerOrderResponse> = await axios({
    method: 'POST',
    url: env.magento.GRAPHQL_URL,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${bearerToken}`,
      Store: getStoreName(),
    },
    data: {
      query: getOrderQuery,
      variables: {
        order_id: orderId,
      },
    },
  })

  if (data.errors) {
    throw data.errors[0].message
  }

  return data.data.getWceiOrder
}
